import Field from "../Field";

export default class CalculationPropertiesRowField extends Field {

    // Tells issue-collector that this is a pseudo-field that really is collection of some fields.
    __collection = true

    constructor(name, step, fields) {
        super(name, step)

        this._text = fields.text
        this.temperature = fields.temperature
        this.pressure = fields.pressure
        this.pn = fields.pn
    }

    get text() {
        return this._text;
    }

    getContaintedFields() {
        return [this.temperature, this.pressure, this.pn]
    }
}
